"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HOT_MARKETS_OUTCOME_TYPES = exports.CLIENT_FILTERED_PROBS_MAP = exports.HOT_PROBS_MARKETS_OUTCOMES_MAP = void 0;
const betweb_openapi_axios_1 = require("betweb-openapi-axios");
const mapValues_1 = __importDefault(require("lodash/mapValues"));
const pick_1 = __importDefault(require("lodash/pick"));
const types_1 = require("./types");
// TODO Move HOT_PROBS_MARKETS_OUTCOMES_MAP management to betweb-admin side
exports.HOT_PROBS_MARKETS_OUTCOMES_MAP = {
    [betweb_openapi_axios_1.HotProbabilityMarketType.MatchWinnerX3]: [
        {
            outcomeTypesName: ['W1'],
            mainOutcomeType: types_1.MainOutcomeTypes.W1,
            title: ['w1'],
        },
        {
            outcomeTypesName: ['WX'],
            mainOutcomeType: types_1.MainOutcomeTypes.WX,
            title: ['X'],
        },
        {
            outcomeTypesName: ['W2'],
            mainOutcomeType: types_1.MainOutcomeTypes.W2,
            title: ['w2'],
        },
    ],
    [betweb_openapi_axios_1.HotProbabilityMarketType.MatchWinnerX2]: [
        {
            outcomeTypesName: ['W1_X2'],
            mainOutcomeType: types_1.MainOutcomeTypes.W1_X2,
            title: ['w1'],
        },
        {
            outcomeTypesName: ['W2_X2'],
            mainOutcomeType: types_1.MainOutcomeTypes.W2_X2,
            title: ['w2'],
        },
    ],
    [betweb_openapi_axios_1.HotProbabilityMarketType.DoubleChance]: [
        {
            outcomeTypesName: ['W1X'],
            mainOutcomeType: types_1.MainOutcomeTypes.W1X,
            title: ['1X'],
        },
        {
            outcomeTypesName: ['W12'],
            mainOutcomeType: types_1.MainOutcomeTypes.W12,
            title: ['12'],
        },
        {
            outcomeTypesName: ['WX2'],
            mainOutcomeType: types_1.MainOutcomeTypes.WX2,
            title: ['X2'],
        },
    ],
    [betweb_openapi_axios_1.HotProbabilityMarketType.Handicap]: [
        {
            outcomeTypesName: ['HC1'],
            mainOutcomeType: types_1.MainOutcomeTypes.HC1,
            withParam: true,
            isDoubleCell: true,
            title: ['handicap', { num: 1 }],
        },
        {
            outcomeTypesName: ['HC2'],
            mainOutcomeType: types_1.MainOutcomeTypes.HC2,
            withParam: true,
            isDoubleCell: true,
            title: ['handicap', { num: 2 }],
        },
    ],
    [betweb_openapi_axios_1.HotProbabilityMarketType.Total]: [
        {
            outcomeTypesName: ['TO'],
            mainOutcomeType: types_1.MainOutcomeTypes.TO,
            title: ['total over'],
        },
        {
            outcomeTypesName: ['TU'],
            mainOutcomeType: types_1.MainOutcomeTypes.TU,
            title: ['total under'],
        },
    ],
    [betweb_openapi_axios_1.HotProbabilityMarketType.HandicapWithOt]: [
        {
            outcomeTypesName: ['HC1O'],
            mainOutcomeType: types_1.MainOutcomeTypes.HC1O,
            withParam: true,
            isDoubleCell: true,
            title: ['handicap overtime', { num: 1 }],
        },
        {
            outcomeTypesName: ['HC2O'],
            mainOutcomeType: types_1.MainOutcomeTypes.HC2O,
            withParam: true,
            isDoubleCell: true,
            title: ['handicap overtime', { num: 2 }],
        },
    ],
    [betweb_openapi_axios_1.HotProbabilityMarketType.TotalWithOt]: [
        {
            outcomeTypesName: ['TOO'],
            mainOutcomeType: types_1.MainOutcomeTypes.TOO,
            title: ['total over'],
        },
        {
            outcomeTypesName: ['TUO'],
            mainOutcomeType: types_1.MainOutcomeTypes.TUO,
            title: ['total under'],
        },
    ],
    [betweb_openapi_axios_1.HotProbabilityMarketType.MatchWinnerX2WithOt]: [],
    [betweb_openapi_axios_1.HotProbabilityMarketType.Unknown]: [],
};
/*
 Handicaps and Totals are filtered on client side to be shown in the events list as "main probs"
 */
exports.CLIENT_FILTERED_PROBS_MAP = (0, mapValues_1.default)((0, pick_1.default)(exports.HOT_PROBS_MARKETS_OUTCOMES_MAP, [
    betweb_openapi_axios_1.HotProbabilityMarketType.Handicap,
    betweb_openapi_axios_1.HotProbabilityMarketType.HandicapWithOt,
    betweb_openapi_axios_1.HotProbabilityMarketType.Total,
    betweb_openapi_axios_1.HotProbabilityMarketType.TotalWithOt,
]), (outcomes) => outcomes.map((outcome) => outcome.mainOutcomeType));
exports.HOT_MARKETS_OUTCOME_TYPES = exports.CLIENT_FILTERED_PROBS_MAP;
//# sourceMappingURL=constants.js.map